module.exports = __webpack_public_path__ + "img/地图配置.aa084fbb.svg";